import React from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/home/Sidebar.js";
import VideoLesson from "../courses/VideoLesson.js";
import "../../assets/scss/Lesson.scss";
import { useFetchStrapiData } from "../../config/strapiService.js";
import { PageSkeleton } from "../../config/utils.js";

const LessonPage = () => {
	const { quizData } = useFetchStrapiData();
	const { subjectSlug, courseSlug, unitSlug, lessonSlug, lessonId } =
		useParams();

	// Handle undefined parameters if needed
	if (!subjectSlug || !courseSlug || !unitSlug || !lessonSlug || !lessonId) {
		console.error("Missing parameters:", {
			subjectSlug,
			courseSlug,
			unitSlug,
			lessonSlug,
			lessonId,
		});
		return <div>Error: Invalid URL</div>;
	}

	if (!quizData) {
		return <PageSkeleton />;
	}

	// Find the current unit and lesson
	const currentUnit = quizData?.units?.find((unit) => unit.slug === unitSlug);
	const currentLesson = currentUnit?.lessons?.find(
		(lesson) =>
			lesson.id === parseInt(lessonId) && lesson.slug === lessonSlug
	);

	if (!currentLesson) {
		console.error("Lesson not found:", {
			subjectSlug,
			courseSlug,
			unitSlug,
			lessonSlug,
			lessonId,
		});
		return (
			<div>There are currently no lessons available for this course.</div>
		);
	}

	const lessonData = {
		title: `Lesson ${currentUnit?.lessons?.findIndex((lesson) => lesson.id === currentLesson.id) + 1}: ${currentLesson.title}`,
		videoUrl: currentLesson.videoUrl,
	};

	return (
		<div className="lesson-page">
			<Sidebar />
			<main className="lesson-page__main">
				<VideoLesson
					videoUrl={lessonData.videoUrl}
					lessonTitle={lessonData.title}
				/>
			</main>
		</div>
	);
};

export default LessonPage;
